// Material Kit 2 React pages
import Services from "pages/LandingPages/Services";

export default function ContactUsPage() {
  return <Services />;
}
